import loadable from '@loadable/component'

const ShopByBrand = loadable(
  () => import(
    './ShopByBrand.component'
  ),
)

export default ShopByBrand
